<template>
  <Card flat class="nch--blog-share">
    <h4><i class="mdi mdi-share-variant"></i>{{ $t('blog.share') }}</h4>
    <div class="nch--blog-socials">
      <button
        style="--social-color: #4866AA"
        :disabled="!slug"
        :title="$t('blog.share_on', { social: 'Facebook' })"
        @click="open(facebook)"
      >
        <i class="mdi mdi-facebook"></i>
      </button>
      <button
        style="--social-color: #3477B5"
        :disabled="!slug"
        :title="$t('blog.share_on', { social: 'Linkedin' })"
        @click="open(linkedin)"
      >
        <i class="mdi mdi-linkedin"></i>
      </button>
      <button
        style="--social-color: #4BAAE0"
        :disabled="!slug"
        :title="$t('blog.share_on', { social: 'Twitter' })"
        @click="open(twitter)"
      >
        <i class="mdi mdi-twitter"></i>
      </button>
      <button
        style="--social-color: #6ac19c"
        :title="$t('blog.copy_url')"
        :disabled="!slug"
        @click="copy"
      >
        <i class="mdi mdi-link"></i>
      </button>
    </div>
  </Card>
</template>
<script>
import Card from '../../common/Card';

export default {
  name: 'Share',
  components: {
    Card,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    facebook() {
      const api = '//www.facebook.com/sharer/sharer.php';
      return this.getUrl(api, {
        u: this.url,
      });
    },
    linkedin() {
      const api = '//www.linkedin.com/shareArticle';
      return this.getUrl(api, {
        title: this.title,
        url: this.url,
      });
    },
    twitter() {
      const api = '//twitter.com/intent/tweet';
      return this.getUrl(api, {
        text: this.title,
        url: this.url,
      });
    },
    title() {
      return this.post.translation.title;
    },
    slug() {
      return this.post.translation.slug;
    },
    url() {
      return `https://${location.host}/blog/post/${this.slug}`;
    },
  },
  methods: {
    getUrl(api, params) {
      const query = Object.keys(params)
        .reduce((url, key) => (`${url}${key}=${params[key]}&`), '');
      return `${api}?${query}`;
    },
    copy() {
      const $input = document.createElement('input');
      $input.value = this.url;
      $input.style.position = 'absolute';
      $input.style.left = '-9999px';
      document.body.appendChild($input);
      $input.select();
      $input.setSelectionRange(0, 99999);
      document.execCommand('copy');
      document.body.removeChild($input);
    },
    open(url) {
      window.open(url, 'newwindow', 'width=800,height=600');
      return false;
    },
  },
};
</script>
<style scoped>
.nch--blog-share {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  justify-self: flex-start;
}
.nch--blog-share h4 {
  text-transform: uppercase;
}
.nch--blog-share button {
  border: none;
  margin: 0.3rem;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--blog-text);
  background-color: #efefef;
}
.nch--blog-share button i {
  vertical-align: middle;
}
.nch--blog-share button:not([disabled]):hover {
  color: #fff;
  background-color: var(--social-color);
}
.nch--blog-socials {
  display: flex;
  width: 100%;
  max-width: 300px;
  justify-content: space-between;
}
</style>
